import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithubSquare, faItchIo, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import classes from "./Navigation.module.css";

function Navigation(props) {
	const [isNavCollapsed, setIsNavCollapsed] = useState(true);

	useEffect(() => {
		const handleScroll = (event) => {
			var top = window.scrollY;
			if (top >= 100) {
				setIsNavCollapsed(false);
			}
			else {
				setIsNavCollapsed(true);
			}
		};
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		<nav className={classes.navBar + " " + (isNavCollapsed ? classes.hidden : "")} style={{"--bgColor":props.bgColor}}>
			<Link to="/" className={classes.home}>Home</Link>
			<div className={classes.socialIconsSmaller}>
				<a href="https://github.com/Zeyt8">
					<FontAwesomeIcon icon={faGithubSquare} className={classes.lighter} />
				</a>
				<a href="https://www.linkedin.com/in/bogdan-foca-520a3113a/">
					<FontAwesomeIcon icon={faLinkedin} className={classes.lighter} />
				</a>
				<a href="https://zeyt8.itch.io/">
					<FontAwesomeIcon icon={faItchIo} className={classes.lighter} />
				</a>
			</div>
		</nav>
	);
}

export default Navigation;
